import moment from 'moment'
import { formatWithMask, Mask } from 'react-native-mask-input'
import { TimeFormat } from '../types/scheduleTypes'
import { useTranslation } from 'react-i18next'

// types
type KeyValue = {
  [key: string]: string|number
}

const capitalizeFirstLetter = (text: string): string => {
  return text.charAt(0).toUpperCase() + text.slice(1)
}

const validateEmail = (email: string): null | string[] => {
  const pattern: RegExp =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return String(email).toLowerCase().match(pattern)
}

const validatePassword = (password: string): boolean => {
  const pattern: RegExp = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,25}$/
  return pattern.test(password)
}

// const validateSSN = (ssn: string): boolean => {
//   const pattern: RegExp = /^\d{3}-\d{2}-\d{4}$/
//   return pattern.test(ssn)
// }
const validateSSN = (
  ssn: string | null | undefined
): { valid: boolean; message: string } => {
  if (ssn === undefined || ssn === null || ssn === '')
    return {
      valid: false,
      message: 'Please enter SSN'
    }

  // if (ssn.length !== 9) {
  //   return {
  //     valid: false,
  //     message: 'It should match the format "123-45-6589"'
  //   }
  // }

  // check for invalid combinations in positions 1-3
  // const invalidCombinations: string[] = [
  //   '000',
  //   '666',
  //   ...Array.from({ length: 100 }, (_, i) =>
  //     (i + 900).toString().padStart(3, '0')
  //   )
  // ]

  // if (invalidCombinations.includes(ssn.slice(0, 3))) {
  //   return {
  //     valid: false,
  //     message:
  //       'The 1-3 positions should not be belong "000", "666" or "900-999".'
  //   }
  // }

  // check for invalid combinations in positions 4-5
  // if (ssn.slice(3, 5) === '00') {
  //   return {
  //     valid: false,
  //     message: 'The 4-5 positions should not be "00".'
  //   }
  // }

  // check for invalid combinations in positions 6-9
  // if (ssn.slice(5) === '0000') {
  //   return {
  //     valid: false,
  //     message: 'The 6-9 positions should not be "0000".'
  //   }
  // }
  // let isSequential = true;

  // for (let i = 0; i < ssn.length - 1; i++) {

  //   if (parseInt(ssn[i]) !== parseInt(ssn[i + 1]) - 1) {

  //     isSequential = false;

  //     break;

  //   }

  // }
  // if (isSequential) {

  //   return {

  //     valid: false,

  //     message: 'The SSN should not have all sequential digits (e.g., "123-45-6789").'

  //   };

  // }

  return {
    valid: true,
    message: 'Valid'
  }
}
const validatelength = (ssn: string) => {
  let isValid = false
 
 
  if (ssn?.length == 9) {
    isValid = true
  }
  return isValid
}
const validatecombination = (ssn: string) => {
  let isvalid = true
  const invalidCombinations: string[] = [
    '000',
    '666',
    ...Array.from({ length: 100 }, (_, i) =>
      (i + 900).toString().padStart(3, '0')
    )
  ]

  if (invalidCombinations.includes(ssn?.slice(0, 3))) {
    isvalid = false
  }
  return isvalid
}
const validateserial3to5 = (ssn: string) => {
  let isValid = true
  if (ssn?.substring(4, 6) == '00') {
    isValid = false
  }
  return isValid
}

const validate6to9 = (ssn: string) => {
  let isValid = true
  if (ssn?.includes('0000', 5)) {
    isValid = false
  }
  return isValid
}
const validateserialnumber = (ssn: string) => {
  let isSequential = true
  if (ssn?.includes('123-45-6789')) {
    isSequential = false
  }
  return isSequential
}

const validatePhone = (phone: string): boolean => {
  const pattern: RegExp = /^\(\d{3}\)\s\d{3}-\d{4}$/
  return pattern.test(phone)
}

const validateZipCode = (zipCode: string): boolean => {
  const pattern: RegExp = /^\d{5}(-\d{4})?$/
  return pattern.test(zipCode)
}

const validateDOBFormat = (date: string): boolean => {
  const pattern: RegExp = /^\d{2}\/\d{2}\/\d{4}$/
  if (!pattern.test(date)) return false
  const parts: string[] = date.split('/')
  const month: number = parseInt(parts[0], 10)
  const day: number = parseInt(parts[1], 10)
  const year: number = parseInt(parts[2], 10)
  if (month < 1 || month > 12) return false
  if (day < 1 || day > 31) return false
  if (year < 1) return false
  return true
}

const validateDate = (birthday: string): boolean => {
  // Check if the input string is in the correct format of MM/DD/YYYY
  const dateRegex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/
  if (!dateRegex.test(birthday)) {
    return false
  }

  // Split the input string into month, day, and year components
  const [month, day, year] = birthday.split('/').map(Number)

  // Check if the year is within the valid range
  // const currentYear = new Date().getFullYear()
  // const minYear = currentYear - 120 // minimum age of 1 year old
  // const maxYear = currentYear // maximum age of 120 years old
  // if (year < minYear || year > maxYear) {
  //   return false
  // }

  // Check if the day is valid for the given month and year
  const isLeapYear = (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0
  const daysInMonth = [
    31,
    isLeapYear ? 29 : 28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
  ]
  if (day > daysInMonth[month - 1]) {
    return false
  }

  // If we reach this point, the input string is a valid birthday within the year boundaries, in the correct format, and with a valid day for the given month and year
  return true
}

const validateDOBYear = (
  birthday: string,
  youngest: number,
  oldest: number
): boolean => {
  const date = new Date(birthday)
  const year = date.getFullYear()

  // Check if the year is within the valid range
  const currentYear = new Date().getFullYear()
  const minYear = currentYear - oldest // minimum age of youngest year old
  const maxYear = currentYear - youngest // maximum age of oldest years old
  if (year < minYear || year > maxYear) {
    return false
  }

  return true
}

const customMasks = {
  USA_SSN: [/\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
  USA_ZIPCODE: [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
  USA_PHONE: [
    '(',
    /\d/,
    /\d/,
    /\d/,
    ')',
    ' ',
    /\d/,
    /\d/,
    /\d/,
    '-',
    /\d/,
    /\d/,
    /\d/,
    /\d/
  ]
}

const addLeadingZero = (number: number): string | number => {
  return number < 10 ? '0' + number : number
}

const scheduleTimeRange: {
  id: number
  hour: number
  minute: number
  period: 'am' | 'pm'
}[] = [
  { id: 1, hour: 12, minute: 0, period: 'am' },
  { id: 2, hour: 12, minute: 15, period: 'am' },
  { id: 3, hour: 12, minute: 30, period: 'am' },
  { id: 4, hour: 12, minute: 45, period: 'am' },
  { id: 5, hour: 1, minute: 0, period: 'am' },
  { id: 6, hour: 1, minute: 15, period: 'am' },
  { id: 7, hour: 1, minute: 30, period: 'am' },
  { id: 8, hour: 1, minute: 45, period: 'am' },
  { id: 9, hour: 2, minute: 0, period: 'am' },
  { id: 10, hour: 2, minute: 15, period: 'am' },
  { id: 11, hour: 2, minute: 30, period: 'am' },
  { id: 12, hour: 2, minute: 45, period: 'am' },
  { id: 13, hour: 3, minute: 0, period: 'am' },
  { id: 14, hour: 3, minute: 15, period: 'am' },
  { id: 15, hour: 3, minute: 30, period: 'am' },
  { id: 16, hour: 3, minute: 45, period: 'am' },
  { id: 17, hour: 4, minute: 0, period: 'am' },
  { id: 18, hour: 4, minute: 15, period: 'am' },
  { id: 19, hour: 4, minute: 30, period: 'am' },
  { id: 20, hour: 4, minute: 45, period: 'am' },
  { id: 21, hour: 5, minute: 0, period: 'am' },
  { id: 22, hour: 5, minute: 15, period: 'am' },
  { id: 23, hour: 5, minute: 30, period: 'am' },
  { id: 24, hour: 5, minute: 45, period: 'am' },
  { id: 25, hour: 6, minute: 0, period: 'am' },
  { id: 26, hour: 6, minute: 15, period: 'am' },
  { id: 27, hour: 6, minute: 30, period: 'am' },
  { id: 28, hour: 6, minute: 45, period: 'am' },
  { id: 29, hour: 7, minute: 0, period: 'am' },
  { id: 30, hour: 7, minute: 15, period: 'am' },
  { id: 31, hour: 7, minute: 30, period: 'am' },
  { id: 32, hour: 7, minute: 45, period: 'am' },
  { id: 33, hour: 8, minute: 0, period: 'am' },
  { id: 34, hour: 8, minute: 15, period: 'am' },
  { id: 35, hour: 8, minute: 30, period: 'am' },
  { id: 36, hour: 8, minute: 45, period: 'am' },
  { id: 37, hour: 9, minute: 0, period: 'am' },
  { id: 38, hour: 9, minute: 15, period: 'am' },
  { id: 39, hour: 9, minute: 30, period: 'am' },
  { id: 40, hour: 9, minute: 45, period: 'am' },
  { id: 41, hour: 10, minute: 0, period: 'am' },
  { id: 42, hour: 10, minute: 15, period: 'am' },
  { id: 43, hour: 10, minute: 30, period: 'am' },
  { id: 44, hour: 10, minute: 45, period: 'am' },
  { id: 45, hour: 11, minute: 0, period: 'am' },
  { id: 46, hour: 11, minute: 15, period: 'am' },
  { id: 47, hour: 11, minute: 30, period: 'am' },
  { id: 48, hour: 11, minute: 45, period: 'am' },
  { id: 49, hour: 12, minute: 0, period: 'pm' },
  { id: 50, hour: 12, minute: 15, period: 'pm' },
  { id: 51, hour: 12, minute: 30, period: 'pm' },
  { id: 52, hour: 12, minute: 45, period: 'pm' },
  { id: 53, hour: 1, minute: 0, period: 'pm' },
  { id: 54, hour: 1, minute: 15, period: 'pm' },
  { id: 55, hour: 1, minute: 30, period: 'pm' },
  { id: 56, hour: 1, minute: 45, period: 'pm' },
  { id: 57, hour: 2, minute: 0, period: 'pm' },
  { id: 58, hour: 2, minute: 15, period: 'pm' },
  { id: 59, hour: 2, minute: 30, period: 'pm' },
  { id: 60, hour: 2, minute: 45, period: 'pm' },
  { id: 61, hour: 3, minute: 0, period: 'pm' },
  { id: 62, hour: 3, minute: 15, period: 'pm' },
  { id: 63, hour: 3, minute: 30, period: 'pm' },
  { id: 64, hour: 3, minute: 45, period: 'pm' },
  { id: 65, hour: 4, minute: 0, period: 'pm' },
  { id: 66, hour: 4, minute: 15, period: 'pm' },
  { id: 67, hour: 4, minute: 30, period: 'pm' },
  { id: 68, hour: 4, minute: 45, period: 'pm' },
  { id: 69, hour: 5, minute: 0, period: 'pm' },
  { id: 70, hour: 5, minute: 15, period: 'pm' },
  { id: 71, hour: 5, minute: 30, period: 'pm' },
  { id: 72, hour: 5, minute: 45, period: 'pm' },
  { id: 73, hour: 6, minute: 0, period: 'pm' },
  { id: 74, hour: 6, minute: 15, period: 'pm' },
  { id: 75, hour: 6, minute: 30, period: 'pm' },
  { id: 76, hour: 6, minute: 45, period: 'pm' },
  { id: 77, hour: 7, minute: 0, period: 'pm' },
  { id: 78, hour: 7, minute: 15, period: 'pm' },
  { id: 79, hour: 7, minute: 30, period: 'pm' },
  { id: 80, hour: 7, minute: 45, period: 'pm' },
  { id: 81, hour: 8, minute: 0, period: 'pm' },
  { id: 82, hour: 8, minute: 15, period: 'pm' },
  { id: 83, hour: 8, minute: 30, period: 'pm' },
  { id: 84, hour: 8, minute: 45, period: 'pm' },
  { id: 85, hour: 9, minute: 0, period: 'pm' },
  { id: 86, hour: 9, minute: 15, period: 'pm' },
  { id: 87, hour: 9, minute: 30, period: 'pm' },
  { id: 88, hour: 9, minute: 45, period: 'pm' },
  { id: 89, hour: 10, minute: 0, period: 'pm' },
  { id: 90, hour: 10, minute: 15, period: 'pm' },
  { id: 91, hour: 10, minute: 30, period: 'pm' },
  { id: 92, hour: 10, minute: 45, period: 'pm' },
  { id: 93, hour: 11, minute: 0, period: 'pm' },
  { id: 94, hour: 11, minute: 15, period: 'pm' },
  { id: 95, hour: 11, minute: 30, period: 'pm' },
  { id: 96, hour: 11, minute: 45, period: 'pm' }
]

const daysOfWeek = () => {
  const { t } = useTranslation()
  return [
    t('sunday'),
    t('monday'),
    t('tuesday'),
    t('wednesday'),
    t('thursday'),
    t('friday'),
    t('saturday')
  ]
}

// const serializeDOB = (date: string) => {
//   return moment(new Date(date), 'MM/DD/YYYY').format('YYYY-MM-DDTHH:mm:ss')
// }

// const deserializeDOB = (date: string) => {
//   return moment(new Date(date), 'YYYY-MM-DDTHH:mm:ss').format('L')
// }

const serializeDOB = (date: string): string => {
  const [month, day, year] = date.split('/')
  return `${year}-${month.padStart(2, '0')}-${day.padStart(
    2,
    '0'
  )}${'T00:00:00'}`
}

const deserializeDOB = (date: string): string => {
  const [year, month, day] = date.slice(0, 10).split('-')
  if (year == '0001') {
    //const newYear = (parseInt(year, 10) + 1999).toString()
    return ``
  }

  return `${month}/${day}/${year}`
}

const convertTo24HourTime = (time: string | null): TimeFormat | null => {
  if (time) {
    // Parse the hour, minute, and AM/PM components of the time string
    const [hourStr, minuteStr, ampm] = time.split(/[: ]/)
    const hour = parseInt(hourStr)
    const minute = parseInt(minuteStr)

    // Calculate the 24-hour hour value
    let hour24 = hour
    if (ampm.toLowerCase() === 'pm' && hour !== 12) {
      hour24 += 12
    } else if (ampm.toLowerCase() === 'am' && hour === 12) {
      hour24 = 0
    }

    // Convert the hour value to a two-digit string
    const hour24Str = hour24.toString().padStart(2, '0')

    // Return the 24-hour time string
    return `${hour24Str}:${minuteStr}:${'00'}`
  }

  return null
}

const convertTo12HourTime = (time: string | null): string | null => {
  if (time) {
    // Parse the hour, minute, and second components of the time string
    const [hourStr, minuteStr, secondStr] = time.split(':')
    const hour = parseInt(hourStr)

    // Determine the AM/PM indicator based on the hour value
    const ampm = hour < 12 ? 'AM' : 'PM'

    // Convert the hour value to a 12-hour value
    const hour12 = hour % 12 || 12

    // Return the 12-hour time string with the AM/PM indicator
    return `${hour12.toString().padStart(2, '0')}:${minuteStr} ${ampm}`
  }

  return null
}

const setMaskedValue = (
  value: string,
  mask: Mask,
  ref: React.MutableRefObject<any>,
  formatValue?: (value: string) => string | null
) => {
  const { masked } = formatWithMask({
    text: formatValue
      ? formatValue(ref.current.values[value])
      : ref.current.values[value],
    mask
  })

  // console.log(`masked ${value}:`, masked)

  ref.current?.setFieldValue(value, masked)
}

const getUnmaskedValue = (value: string, mask: Mask) => {
  const { unmasked } = formatWithMask({
    text: value,
    mask
  })

  return unmasked
}

const mapSelectKey = (options: KeyValue[], key: string): string|number => {
  if (!options || options.length === 0) return null;
  const keys = Object.keys(options[0])

  const selectedOptionIndex = options.findIndex(
    (option) => option[keys[0]] === key
  )

  if (selectedOptionIndex === -1) return null

  return options[selectedOptionIndex][keys[1]]
}

const mapSelectValue = (options: KeyValue[], key: string): string |number=> {
  const keys = Object.keys(options[1])

  const selectedOptionIndex = options.findIndex(
    (option) => option[keys[1]] === key
  )

  if (selectedOptionIndex === -1) return null

  return options[selectedOptionIndex][keys[0]]
}

const AlertWeb = (title: string, message: string) => {
  window.confirm([title, message].filter(Boolean).join('\n'))
}


const getLocalTimeWithTimezoneOffset=()=> {
  const now = new Date();

  const pad = (num) => String(num).padStart(2, '0');

  const year = now.getFullYear();
  const month = pad(now.getMonth() + 1);
  const day = pad(now.getDate());
  const hours = pad(now.getHours());
  const minutes = pad(now.getMinutes());
  const seconds = pad(now.getSeconds());

  // Get timezone offset in minutes and convert to ±HH:MM
  const offsetMinutes = now.getTimezoneOffset();
  const absOffset = Math.abs(offsetMinutes);
  const offsetHours = pad(Math.floor(absOffset / 60));
  const offsetMins = pad(absOffset % 60);
  const sign = offsetMinutes <= 0 ? '+' : '-';

  const timezone = `${sign}${offsetHours}:${offsetMins}`;

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${timezone}`;
}

export {
  capitalizeFirstLetter,
  validateEmail,
  validatePassword,
  validateSSN,
  validateserialnumber,
  validatePhone,
  validateZipCode,
  validateDOBFormat,
  validateDate,
  validateDOBYear,
  validateserial3to5,
  validate6to9,
  validatecombination,
  validatelength,
  customMasks,
  addLeadingZero,
  scheduleTimeRange,
  daysOfWeek,
  serializeDOB,
  deserializeDOB,
  setMaskedValue,
  getUnmaskedValue,
  mapSelectKey,
  mapSelectValue,
  convertTo24HourTime,
  convertTo12HourTime,
  AlertWeb,
  getLocalTimeWithTimezoneOffset
}
